// eslint-disable-next-line valid-jsdoc

import { blankToUndefined } from '../../../utils/QualityUtils'

/**
 * @deprecated use QualityThresholdType
 */
export default class DtoQualityThreshold {
    constructor(obj) {
        this.thresholdCode = obj.thresholdCode
        this.listType = obj.listType
        this.stationType = obj.stationType
        this.parameterCode = blankToUndefined(obj.parameterCode)
        this.unit = blankToUndefined(obj.unit)
        this.station = obj.station
        this.fraction = blankToUndefined(obj.fraction)
        this.threshold1 = obj.threshold1
        this.threshold2 = obj.threshold2
        this.threshold3 = obj.threshold3
        this.threshold4 = obj.threshold4
        this.frType = obj.frType
        this.elementCode = obj.elementCode
        this.seasonality = obj.seasonality
        this.fishCode = obj.fishCode
        this.calciumClass = obj.calciumClass
        this.ph = obj.ph
        this.thresholdType = obj.thresholdType
        this.display = obj.display
        this.discriminant = obj.discriminant
        this.isFromChild = obj.isFromChild
    }
}

